module.exports = __webpack_public_path__ + "static/media/crown-g.90381eb0.svg";